import React from "react";
import { Flex, Box, Image, HStack } from "@chakra-ui/react";
import Marquee from "react-fast-marquee";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const Section4 = () => {
  const data = [
    { name: "Jan 2024", balance: 100 },
    { name: "Feb 2024", balance: 500 },
    { name: "Mar 2024", balance: 1500 },
    { name: "Apr 2024", balance: 3000 },
  ];
  const nfts1 = [
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL0p1OUNrV3RWLTFPa3ZmNDV3bzhVY3RSLU05SGUyUGpJTFAwb092eEU4OUF5aVBQR3RyUjNneXN1MVpneTBoamQyeEtJZ2pKSnRXSWMweWJqNFZkN3d2OHQzcHhER0hvSkJ6REI9czEyMA==",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9iYWZrcmVpZGxocndlM2JrbXN2dHByM3d0ZnNtN3h3eWpsdmV2cnI2bnVucmllNGRpbG1kbzJnN2J6eQ==",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbVNUckE1cGNmNzVUTlpSV1pjNUZpSnJhakp6bU1HQ3dmQ3FmVkFwRGtnY0tF",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbWJKaXQxYTlKcDM1RDJBWmRpVGRmTG42SkNYUVNibjFMdzIzN3FaV2ZDTWZl",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL0F2SEk1T2dDZHBMaWhQblE0OFJhdF92OHh5LUlORXNEQU44aWQ4bmFhWnJINkp3Y1lxc0Y2TGN2UUFuRG91YmJlbVJvU3psOUZnOE80T3poZUF3VDNtU1VTNURwWWU1NE95eUxydz1zMTIw",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pLnNlYWRuLmlvL2djcy9maWxlcy9jNmNiMGIxZDZmMmFiNjFjMGVmYWNmMDBlNjJlMjIzMC5qcGc/dz01MDAmYXV0bz1mb3JtYXQ=",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL0UwcENDT21CNEtDaFMtZFFmNFdFOFpCVEVzQ05aSHJJVmF4TWxweklfZVFuQmhXYWdKQVp6ZTlVeVNyT1pXc25wMmNHMVhzay1NTklONjdRdTZ6enBxVlpCcXRsY3BMczdZNlY9czEyMA==",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbU5xeXRwcWZhZWFmVEhWYmZmR1U1dnBYY3A5Q3lSRnhhVDk3RnVyaHNuUTd6",
  ];
  const nfts2 = [
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbVZoWHZ5S3NORURha0ZzdXRxUWRkdG90V3JuMjhZTllLMjh0azVzRWttaExX",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9vcGVuc2VhdXNlcmRhdGEuY29tL2ZpbGVzLzlkNjE2OGU3MzFhZmQwMmQ1ZTg3OGViMDM4NzZjZmQ0LmdpZg==",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbVROUmR3WXZkNW5zTVZvVUdYNEd1MlpXd2diS2J1OU5OZHhETHRjd0VFOEty",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbVNmclRXWmtFempLVHhnMWV1TTFpUW1NbnV4M3RBVmRON256VWJxZjhDREZr",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL1A2RTQwMXF1azF2eFlTRVdaOU40QlhiVk1TUVg1SGc2azA1bHdfdGgySWpGQTlDanhVcENWSjdjLUpwNF9lSXNENGU2Y0hyQjZjRWY0Vnd1ME03UXpnZ05aYThJQVlkVHBzdVU9czEyMA==",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbWNiOUJ5eVk5c3lwcDFZM000dmZZM1hiZ0ViOVg3R2VFdGJlNGZmQmpQdmJG",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pLnNlYWRuLmlvL2djcy9maWxlcy9mZDVlOGZhNmJiNGUzOWNkZGNkYjRjOWEwYjY4NWM1ZS5wbmc/dz01MDAmYXV0bz1mb3JtYXQ=",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9iYWZ5YmVpaHYzNWNsYXl1czZ2bTNkazRjZ3pjdTRnZWp5Y2ljZWZvZWlldHRyZnZvYWd0ajdvZWxxcQ==",
  ];
  const nfts3 = [
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbWE2UDhGbUxDeU14SG1CRk1OblhOOVlaNXlzV0ZpZWVYU29zZ3lEWEhYOHlt",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pLnNlYWRuLmlvL2djcy9maWxlcy9mNzdmMGYyY2MyN2RkNDI3YzY5YzY4ZTgxYmZiMGI5Ny5naWY/dz01MDAmYXV0bz1mb3JtYXQ=",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbWJIMU50cG92WnRTQk5ySjFWSjRhQVlSbmc0YnFkZHl5NkFSOGN0NlN0RWtW",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pLnNlYWRuLmlvL2djcy9maWxlcy80YWZhZGM1MTBlYjE3YThjOTZkMjVhZWNkMjNiMDAxYS5wbmc/dz01MDAmYXV0bz1mb3JtYXQ=",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbVhUOGQxMmJub2ZKd2NuYXFzQ1dpNGpiYjZNY25TTUJOOHBwM1hydDJFQzJW",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2p1NnZEUjBzYkV2cVQwYkFiNFFQRXpZTXpwUmVFbGxEWjVNbElDdHhxSnU3Nkc1VXJaMGNULXc2WDNNemY5ZThLWFpYSkdOSXlYR0RSQW9MLXFsYUFwaUpzajI3WmRiT1k1VnZDQT1zMTIw",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL1U3Q2FjY3FFM2xydHdyVDl1Wk5yRXRybm13d0J0WDV5dEE0bEtQV0t2MjZfcko0aHhndDNTRFF5akcxQ2x6Mk9SQU1LM0xXZU1XaGZUYlZFUVl3X1llclJHY05kMm9ncXZxN2FqQT1zMTIw",
    "https://assets.raribleuserdata.com/prod/v1/image/t_avatar_big/aHR0cHM6Ly9pcGZzLnJhcmlibGV1c2VyZGF0YS5jb20vaXBmcy9RbWVMMkFZaThVTUw0SDlBNU5kbXpwUWhicGIzWlYxaFQ5ZHVodUo3bVE1SmM3",
  ];
  return (
    <div>
      <Flex
        mt={{ base: "100px", md: "150px" }}
        w="100%"
        alignItems="center"
        justifyContent="center"
        flexDir={{ base: "column", md: "row" }}
      >
        <Box
          w={{ base: "90%", md: "35%" }}
          p={{ base: "20px", md: "30px" }}
          bg="#1a1a1a"
          borderRadius={{ base: "12px", md: "20px" }}
          h={{ base: "550px" }}
        >
          <Box
            mt="10px"
            backdrop-filter="blur(10px)"
            w={{ base: "100%", md: "100%" }}
          >
            <Marquee gradient={false}>
              <HStack
                mt={{
                  base: "10px",
                  md: "10px",
                  lg: "10px",
                  "2xl": "10px",
                }}
                mr={{ base: "10px", "2xl": "20px" }}
              >
                {nfts1.map((e, i) => {
                  return (
                    <>
                      <Image
                        borderRadius="10px"
                        boxSize={{ base: "35px", md: "50px" }}
                        src={e}
                        bg="white"
                      />
                    </>
                  );
                })}
              </HStack>
            </Marquee>
          </Box>
          <Box
            mt="10px"
            backdrop-filter="blur(10px)"
            w={{ base: "100%", md: "100%" }}
          >
            <Marquee direction="right" gradient={false}>
              <HStack
                mt={{
                  base: "10px",
                  md: "10px",
                  lg: "10px",
                  "2xl": "10px",
                }}
                mr={{ base: "10px", "2xl": "20px" }}
              >
                {nfts2.map((e, i) => {
                  return (
                    <>
                      <Image
                        borderRadius="10px"
                        boxSize={{ base: "35px", md: "50px" }}
                        src={e}
                        bg="white"
                      />
                    </>
                  );
                })}
              </HStack>
            </Marquee>
          </Box>
          <Box
            mt="10px"
            backdrop-filter="blur(10px)"
            w={{ base: "100%", md: "100%" }}
          >
            <Marquee gradient={false}>
              <HStack
                mt={{
                  base: "10px",
                  md: "10px",
                  lg: "10px",
                  "2xl": "10px",
                }}
                mr={{ base: "10px", "2xl": "20px" }}
              >
                {nfts3.map((e, i) => {
                  return (
                    <>
                      <Image
                        borderRadius="10px"
                        boxSize={{ base: "35px", md: "50px" }}
                        src={e}
                        bg="white"
                      />
                    </>
                  );
                })}
              </HStack>
            </Marquee>
            <Box
              mt="10px"
              backdrop-filter="blur(10px)"
              w={{ base: "100%", md: "100%" }}
            >
              <Marquee direction="right" gradient={false}>
                <HStack
                  mt={{
                    base: "10px",
                    md: "10px",
                    lg: "10px",
                    "2xl": "10px",
                  }}
                  mr={{ base: "10px", "2xl": "20px" }}
                >
                  {nfts1.map((e, i) => {
                    return (
                      <>
                        <Image
                          borderRadius="10px"
                          boxSize={{ base: "35px", md: "50px" }}
                          src={e}
                          bg="white"
                        />
                      </>
                    );
                  })}
                </HStack>
              </Marquee>
            </Box>
            <Box
              mt="10px"
              backdrop-filter="blur(10px)"
              w={{ base: "100%", md: "100%" }}
            >
              <Marquee gradient={false}>
                <HStack
                  mt={{
                    base: "10px",
                    md: "10px",
                    lg: "10px",
                    "2xl": "10px",
                  }}
                  mr={{ base: "10px", "2xl": "20px" }}
                >
                  {nfts3.map((e, i) => {
                    return (
                      <>
                        <Image
                          borderRadius="10px"
                          boxSize={{ base: "35px", md: "50px" }}
                          src={e}
                          bg="white"
                        />
                      </>
                    );
                  })}
                </HStack>
              </Marquee>
            </Box>
          </Box>
          <Box
            mt="20px"
            fontWeight="600"
            fontSize={{ base: "30px", md: "32px" }}
          >
            Detailed NFT data
          </Box>

          <Box fontSize={{ base: "14px", md: "14px" }} mt="10px">
            ChainPulse returns detailed NFT data from your wallet addresses,
            complete with detailed information and metadata for you to have
            access to your NFTs info at a glance.
          </Box>
        </Box>
        <Box
          ml={{ base: "0px", md: "40px" }}
          mt={{ base: "20px", md: "0px" }}
          w={{ base: "90%", md: "35%" }}
          p={{ base: "20px", md: "30px" }}
          bg="#1a1a1a"
          borderRadius={{ base: "12px", md: "20px" }}
          h={{ base: "550px" }}
        >
          <ResponsiveContainer width="100%" height={300}>
            <LineChart
              width={800}
              height={400}
              data={data}
              margin={{
                top: 20,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />

              <Line
                type="monotone"
                dataKey="balance"
                stroke="#8884d8"
                activeDot={{ r: 8 }}
              />
            </LineChart>
          </ResponsiveContainer>
          <Box
            mt="20px"
            fontWeight="600"
            fontSize={{ base: "30px", md: "32px" }}
          >
            Detailed Profit and Loss Report
          </Box>

          <Box fontSize={{ base: "14px", md: "14px" }} mt="10px">
            Seen when you bought each token, the lowest and highest prices you
            could have bought at and how much money you made or lost on each
            token and overall.
          </Box>
        </Box>
      </Flex>
    </div>
  );
};

export default Section4;
